import Link from 'next/link';
import { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Category } from '@/api/games';
import { GamesGrid } from '@/components/GamesGrid';
import { useGetCommonStore } from '@/store';
import type { ISearchFallbackScenariosProps } from '..';

import { ScSearchFallbackScenario } from '../styled';

type WageringScenarioProps = ISearchFallbackScenariosProps;

export const WageringScenario: React.FC<WageringScenarioProps> = ({
  gridOptions,
  handleSearchGameClick,
  sendSearchResultAppearance,
  closeModal,
}) => {
  const { t } = useTranslation('lobby');

  const useCommonStore = useGetCommonStore();
  const setState = useCommonStore.setState;

  useEffect(() => {
    sendSearchResultAppearance({ status: 'custom' });

    return () => {
      setState({ gamesByCategories: {} });
    };
  }, [setState]);

  return (
    <ScSearchFallbackScenario>
      <div className="text">
        <p>{t('searchFallback.title')}</p>
        <p>
          <Trans
            components={{
              l: (
                <Link
                  className="link"
                  href="/games/wagering#gamesSection"
                  onClick={closeModal}
                />
              ),
            }}
            i18nKey="searchFallback.subtitle.wagering"
            ns="lobby"
          />
        </p>
      </div>
      <GamesGrid
        category={Category.WAGERING}
        {...gridOptions}
        onDemoClick={(game) => handleSearchGameClick(game, 'custom_wagering')}
        onPlayClick={(game) => handleSearchGameClick(game, 'custom_wagering')}
      />
    </ScSearchFallbackScenario>
  );
};
